import { SvgIcon, SvgIconProps } from "@mui/joy";
import { forwardRef } from "react";

const MiscTask = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
  return (
    <SvgIcon {...props} ref={ref}>
      <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <rect
          x="3.5"
          y="12"
          width="12"
          height="12"
          rx="1"
          transform="rotate(-45 3.5 12)"
          fill="currentColor"
        />
      </svg>
    </SvgIcon>
  );
});

MiscTask.displayName = "MiscTask";

export default MiscTask;
